import React, { Component } from 'react'
import styles from './Background.scss'
//= ({type = 'clear', children}) => (


const Background = ({ type = 'clear', children }) => {
  if (type == 'flattop' || type == 'flattopLarger') {
    return (
      <div className={styles[type]}>
        <div className={styles.skew1}>
          {children}
        </div>
      </div>
    )
  } else if (type == 'flatBottom') {
    return (
      <div className={styles[type]}>
        {children}
      </div>
    )
  }
  else {
    return (
      <div>
        <div className={styles[type]}>
          {children}
        </div>
      </div>
    )
  }
}


export default Background;